module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-details-3-7d508c5dd0524e5403f9991b960f30a4.jpg";